import { createContext, useContext } from "react";
import type { PageTab } from "../lib/pageTabs";

export const PageTabNoteContext = createContext<(tab: PageTab) => void>(() => {});

export function useNotePageTab(): (tab: PageTab) => void {
  return useContext(PageTabNoteContext);
}
